import { useState } from 'react'
import pick from 'lodash-es/pick'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { useNotification } from '../../../../hooks'
import { getTaskUpdateErrorNotificationKey, updateTask } from '../../../Task'
import {
  checkIsBirdviewActivitiesReload,
  checkIsBirdviewActivityDone,
} from '../../DashboardBirdview.utils'

export function useBirdviewQuickActions() {
  const { handleAddErrorNotification } = useNotification()

  const [activityDoneById, setActivityDoneById] = useState(EMPTY_OBJECT)
  const [pendingIds, setPendingIds] = useState(EMPTY_LIST)

  // A reload brings the server state back, so the optimistic values go, except
  // for the in-flight toggles.
  function handleResetActivityDone(sectionKey) {
    if (checkIsBirdviewActivitiesReload(sectionKey)) {
      setActivityDoneById(doneById => pick(doneById, pendingIds))
    }
  }

  function handleActivityToggle(item) {
    const previousDone = checkIsBirdviewActivityDone(item, activityDoneById)
    const done = !previousDone

    setPendingIds(ids => [...ids, item.id])
    setActivityDoneById(doneById => ({ ...doneById, [item.id]: done }))

    updateTask({ done }, item.id)
      .catch(error => {
        // Back to the last known state, not to `item.done`: an earlier toggle
        // the section has not reloaded yet must survive the rollback.
        setActivityDoneById(doneById => ({
          ...doneById,
          [item.id]: previousDone,
        }))
        handleAddErrorNotification(
          getTaskUpdateErrorNotificationKey(
            error,
            'Error.CommonApiRequestFailKey'
          )
        )
      })
      .finally(() => {
        setPendingIds(ids => ids.filter(id => id !== item.id))
      })
  }

  return {
    activityDoneById,
    handleActivityToggle,
    handleResetActivityDone,
    pendingIds,
  }
}
